import { isAuthenticated, popupOpen, token, role } from "./store";

import * as urls from "../json/config.json";

async function authenticate(username, password) {
    let formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    
    try {
        const response = await fetch(urls.auth, {
            method: 'POST',
            body: formData
        });
        if (response.ok) {
            let res = await response.json()
            token.set(res.access_token);
            role.set(res.role);
            isAuthenticated.set(true);
            document.body.classList.remove('modal-open');
            popupOpen.set(false)
        } else {
            throw new Error('Request failed:', response.status);
        }
    } catch (error) {
        console.log(error)
        throw new Error('An error occurred:', error);
    }
}

export default authenticate;